import type { DocMigration } from "../docMigration";

/**
 * Previously, instanceOptionSets were nested inside their archetype option set.
 * This migration moves them to doc.instanceOptionSets.
 */
const migration: DocMigration = {
  id: "20260604_move_instance_option_sets_to_doc_table",
  description: "Move nested instanceOptionSets into doc.instanceOptionSets",
  apply(json, warnings: string[]) {
    const { optionSets } = json;
    const instanceOptionSets = {};

    for (const optionSet of Object.values(optionSets) as any[]) {
      const nestedOptionSets = optionSet.instanceOptionSets;
      if (!nestedOptionSets) {
        continue;
      }

      for (const [id, instance] of Object.entries(nestedOptionSets)) {
        if (!instanceOptionSets[id]) {
          instanceOptionSets[id] = instance;
          continue;
        }
        const existing = instanceOptionSets[id];
        if (JSON.stringify(existing) !== JSON.stringify(instance)) {
          warnings.push("move_instance_option_sets_to_doc_table: duplicate instance option set id ");
        }
      }
      delete optionSet.instanceOptionSets;
    }

    json.instanceOptionSets = instanceOptionSets;
    return json;
  },
};

export default migration;
